/**
 * Portfolio page — Phase 2 implementation.
 * Phase 1 renders a shell with tab structure and a "coming soon" import prompt.
 */

export default function Portfolio() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-white">Investment Portfolio</h1>
      <div className="bg-gray-900 border border-gray-800 rounded-xl p-8 text-center">
        <p className="text-gray-400 mb-2">Portfolio module — Phase 2</p>
        <p className="text-sm text-gray-600">
          CSV import, holdings view, and price tracking are implemented in Phase 2.
          The worker endpoints and parsers are already in place — add your CSVs to unlock this view.
        </p>
      </div>
    </div>
  );
}
